var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-0"},[_c('canvas',_vm._b({ref:"rCanvas",attrs:{"height":"120","width":"160"}},'canvas',{ width: _vm.width },false))])}
var staticRenderFns = []

export { render, staticRenderFns }